import { useQueryClient } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { getHCCApi } from "@nens/threedi/openapi-client";

import { queryDirectly } from "./hooks/query-directly";

const getHccSqliteDownloadQuery = (schematisationId: number, revisionId: number) => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-sqlite-download", schematisationId, revisionId] as const,
    queryFn: () =>
      getHCCApi()
        .schematisationsRevisionsSqliteDownload({
          id: revisionId,
          schematisationPk: schematisationId,
        })
        .then((result) => result.getUrl),
  });
};

export const useHccSqliteDownloadQueryDirectly = () => {
  const queryClient = useQueryClient();
  return (schematisationId: number, revisionId: number) =>
    queryDirectly(queryClient, getHccSqliteDownloadQuery(schematisationId, revisionId));
};
